<template>
  <div class="mainNavWrap">
    <div class="mainNav">
        <ul id="main">
            <li class="menu-item" :class="{active_menu:activeMenu('home')}" @click="linkhome">
                <span class="nav_item">홈</span>
            </li>
            <template v-for="(nav, index) in headnavs" :key="index">
              <li class="menu-item" :class="{active_menu:activeMenu(nav.name)}" v-if="nav.type!=='normal'">
                <span class="nav_item" @click="updateActiveMenu(nav.name)"
                :class="{ 'active': activeMenu(nav.name) }"
                >{{nav.title}}</span>
                <ul class="drop">
                    <div>
                      <li class="menu-item" v-for="(sub, index) in nav.subs[0]"
                      :key="index" @click="updateActiveMenuforSub(nav.name,sub.name)">
                        {{sub.title}}
                      </li>
                      <template v-for="(sub,index) in nav.subs" :key="index">
                        <li v-if="index>0" @click="updateActiveMenuforSub(nav.name,sub.name,1)">
                          {{sub.title}}
                        </li>
                      </template>
                    </div>
                </ul>
              </li>
              <li class="menu-item" :class="{active_menu:activeMenu(nav.name)}" v-else>
                <span class="nav_item" @click="linkitem(nav.routename,nav.name)">{{nav.title}}</span>
                  <ul class="drop">
                    <div>                      
                      <template v-for="(sub,index) in nav.subs" :key="index">
                        <li v-if="index>0" @click="linkitem(sub.name,nav.name)">
                          <font-awesome-icon :icon="sub.icon" v-if="sub.icon" /> {{sub.title}}
                        </li>
                      </template>
                    </div>
                  </ul>
              </li> 
            </template>
                <!-- <li class="menu-item" :class="{active_menu:activeMenu('item')}" >
                    <span class="nav_item" @click="linkitem('/main/item/list')">아이템</span>
                     <ul class="drop">
                        <div>
                          <li class="menu-item" @click="linkitem('/main/item/list')">
                            아이템
                          </li>
                           <li class="menu-item" @click="linkitem('/main/goods/list')">
                            <font-awesome-icon icon="parking" /> P샵 몰
                          </li>
                          <li class="menu-item" @click="linkitem('/mypage/item')" v-if="isAuth">
                            마이아이템
                          </li>
                        </div>
                      </ul>
                </li> -->
          <div id="marker"></div>
        </ul>
      <ul style="display:none">
        <li class="menu-item" v-for="(nav, index) in headnavs" :key="index">
          <span class="nav_item" @click="updateActiveMenu(nav.name)"
          :class="{ 'active': activeMenu(nav.name) }"
          >
            {{nav.title}}
          </span>
            <!-- <ol class="sub-menu" >
              <li class="menu-item" v-for="(sub, index) in nav.subs[0]" :key="index">
                {{sub.title}}
              </li>
            </ol>  -->


        </li>
        <!-- <li>
          <router-link
            to="/main/community/free"
            :class="{ 'router-link-active': subIsActive('/main/community') }"
          >
            <span @click="updateActiveMenu('community')">커뮤니티</span>
          </router-link>
        </li> -->
      </ul>
      <div class="navSpread">
          <div @click="shownav=!shownav" >
              <span v-if="shownav"><span style="font-size:20px"><font-awesome-icon icon="times"/></span></span>
              <p v-else class="navSpreadCont"> 
                <span>전체보기 </span>
                <span style="font-size:20px"> <font-awesome-icon icon="bars"/></span>
              </p>
          </div>
      </div>
    </div>
    <div class="menu-auth">
      <menu-login/>
    </div>

  </div>
  <nav-open :show="shownav"  @close="hidenav" :pos_top="pos_top" />
</template>
<script>
import MenuLogin from '@/components/site/MenuLogin';
import NavOpen from '@/components/site/spreadNav/NavOpen';
import { updateMenu } from '@/utils/menu.js';
import { auth } from '@/components/mixins/auth.js';
export default {
  props:[
    'pos_top'
  ]
  ,
  mixins:[ auth],
  data(){
    return{
      shownav:false,
      headnavs:'' ,

    }
  },
  components:{
      MenuLogin,
      NavOpen
  },
  created() {
    this.headnavs = this.$store.state.menu.menus
    //console.log('서브네비표시작업',this.headnavs);
  },
  methods: {
    // viewSub(event){
    //   //console.log(event);
    //   console.log(event.target.nextSibling);
    //   //event.target.nextSibling.style.display="flex";
    //   event.target.nextSibling.style.visibility = 'hidden';
    // },
    linkhome(){
        this.$router.push('/home');
        //active_menu 클래스를 삭제
        //document.querySelector('.active_menu').classList.remove('active_menu');
        //document.querySelector('.active').classList.remove('active');
        this.$store.commit("menu/setActiveMenu", 'home');
    },
    linkitem(path, activemenu){
        this.$router.push({name:path});
        this.$store.commit("menu/setActiveMenu", activemenu);
    },
    activeMenu(input){
      return input === this.$store.state.menu.activeMenu;
    },
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some((path) => {
        return this.$route.path.indexOf(path) === 0; // current path starts with this path string
        //:active="$route.name.match('라우트이름*')"
      });
    },
    updateActiveMenu(menu) {
      updateMenu(menu,'all', this.$store);
      this.$router.push({
        path: "/main/community/" + menu +"/all"
      });
      //this.$store.commit('menu/setActiveDocument', 'free');
    },
    updateActiveMenuforSub(menu, document,otherlink) {

        updateMenu(menu, document, this.$store);
        if(otherlink ===1)
        {
             this.$router.push({
                path: "/main/community/"+ document
                });
        }else{
             this.$router.push({
            path: "/main/community/" + menu +"/"+ document
            });
        }

        //this.$store.commit('menu/setActiveDocument', 'free');
    },
    hidenav(){
      this.shownav=false;
    },
     async getList(){
      const formData = {
        document: 'all',
        menu:this.getMenu,
        page:1
      }
      try{
        const response = await this.$store.dispatch("posts/fetchLists", formData);
        console.log('게시글리스트업', response);
      }catch(error){
        console.log('리스트업 에러', error)
      }
    }
  },
};
</script>
<style lang="scss" scoped>
$min-width: 110px;
$maincolor: #6BBE92;
$secondarycolor: #ab47bc;

@mixin transform($value){
  -webkit-transform: ($value);
     -moz-transform: ($value);
      -ms-transform: ($value);
          transform: ($value);
}
@mixin transition($value){
  -webkit-transition: ($value);
     -moz-transition: ($value);
      -ms-transition: ($value);
          transition: ($value);
}

*{
  box-sizing: border-box;
}

#main{
  position: relative;
  list-style: none;
  font-weight: 400;
  font-size: 0;
  text-transform: uppercase;
  display: inline-block;
  padding: 0;
  //margin: 50px auto;
  li{
    font-size: 0.8rem;
    display: inline-block;
    position: relative;
    padding: 15px 0;
    cursor: pointer;
    z-index: 5;
    min-width: $min-width;
    text-align:center;
  }
}
li{
  margin: 0;
   .active{
      //border: 1px solid #f391e3 !important;
      color: #f391e3  !important;
    }
}
.drop{
    overflow: hidden;
    list-style: none;
    position: absolute;
    padding: 0;
    width: 100%;
    left: 0;
    top: 77px;
    div{
      @include transform(translate(0,-100%));
      @include transition(all 0.5s 0.1s);
      position: relative;
      height:0;
    }
    li{
      display:block;
      padding: 10px 0 !important;
      width: 100%;
      background: $secondarycolor !important;
      color:white;

    }
    li:hover{
      background:#790e8b !important;
    }
  }
#marker{
  height: 6px;
  background: $secondarycolor !important;
  position: absolute;
  bottom: 0;
  width: $min-width;
  z-index: 2;
  @include transition(all 0.35s);
}

@for $i from 1 through 8{
  #main li:nth-child(#{$i}){
    &:hover ul div{
     height:100%;
     @include transform(translate(0,0));
    }
    &:hover ~ #marker{
      @include transform(translate(#{(-1+$i)*$min-width},0));
    }
    &.active_menu ~ #marker{
      @include transform(translate(#{(-1+$i)*$min-width},0));
    }

  }
}



.mainNavWrap{
    width:100%;
    display: flex;
    justify-content: space-between;
    .mainNav{
        display:flex;
        align-items: center;
        justify-content: space-between;
        .navSpread{
          cursor:pointer;
          .navSpreadCont{
            display: flex;
            justify-content: center;
            span{
              line-height: 20px;
              padding:0 2px;
            }
          }
        }
    }
    .menu-auth{
      display:flex;
      align-items: center;
    }

}
</style>
